import React, { useRef } from "react";
import { message, Popover, List, Avatar, Spin } from "antd";
import { Button } from "antd";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { DownloadOutlined } from "@ant-design/icons";
import { loadJsonToExcelData } from "../appRedux/actions/Reports";

const ExportExcel = (props) => {
  const dispatch = useDispatch();
  const getReduxJsonToExcelData = useSelector(
    ({ Reports }) => Reports.jsonToExcelData
  );
  const title = props && props.title ? props.title : "Json to Excel";
  const fileName = props && props.fileName ? props.fileName : "Json to Excel";

  React.useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (getReduxJsonToExcelData && getReduxJsonToExcelData.length > 0) {
        downloadExcel(getReduxJsonToExcelData);
        dispatch(loadJsonToExcelData([]));
      }
    }
    return () => (mounted = false);
  }, [getReduxJsonToExcelData]);

  const downloadExcel = (objData) => {
    if (objData && objData[0]) {
      const csvContent = createCsvContent(objData);
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const downloadLink = document.createElement("a");
      const url = URL.createObjectURL(blob);
      downloadLink.setAttribute("href", url);
      downloadLink.setAttribute("download", `${fileName}.csv`);
      downloadLink.style.visibility = "hidden";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      URL.revokeObjectURL(url);
    } else {
      message.error("No Data in Json Object");
    }
  };

  const createCsvContent = (data) => {
    let csvContent = "";
    // Get headers
    const headers = Object.keys(data[0]);
    csvContent += headers.join(",") + "\n";
    // Add rows
    for (let row of data) {
      const values = Object.values(row);
      csvContent += values.join(",") + "\n";
    }
    return csvContent;
  };

  return (
    <>
      <p>
        <span>
          <DownloadOutlined className="dk-btn-icon-align" />{" "}
        </span>{" "}
        {title}
      </p>
    </>
  );
};

export default ExportExcel;
